import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class ExternalDbEdit extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  async componentDidMount() {
    const { actions } = this.props;
    const { dbUuid, projectId, version } = this.props.match.params;
    await this.props.actions.getDataEdit({ projectId, dbUuid, version });
    await actions.getXanoExternalDb({ projectId, version, dbUuid });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
  }
  handleCreateButtonClick = (item, index) => {
    const { match, history, dataConnector } = this.props;
    const { projectId, dbUuid, version } = match.params;
    const { xanoApiAccessToken } = dataConnector.getDataEditOne.getdata.setting;
    history.push(`/data-connector/${version}/v/${projectId}/xano-table-schema/${dbUuid}`, {
      collectionid: item.id,
      token: xanoApiAccessToken,
    });
  };
  handleUpdate = (obj) => {
    const { projectId, dbUuid, version } = this.props.match.params;
    const { getdata } = this.props.dataConnector.getDataEditOne;
    this.props.history.push(`/data-connector/${version}/v/${projectId}/update-page/${dbUuid}`, {
      collectionobj: obj,
      getdata,
    });
  };
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  renderCollectionCard = (item, index) => {
    const { collectionList } = this.props.dataConnector;
    const name = item.name;
    const fields = item.fields;
    const matchingObject = collectionList.find((obj) => obj.orgCollectionName === name);
    return (
      <div className="card card--user-profile ml-4 card--collection-source col-md-4" key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject ? (
              <h5 className="avatar__title js-user-name" title={name}>
                {name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={name}>
                {name}
              </h5>
            )}
            {item.fields ? (
              <p>Number of fields: {Object.keys(fields).length}</p>
            ) : (
              <p>Number of fields: 0</p>
            )}
            {matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
            {matchingObject ? (
              <button
                className="btn btn-theme-submit btn-md"
                onClick={() => {
                  this.handleUpdate(item, index);
                }}
              >
                <i className="wb webconnect-save-regular"></i> Update
              </button>
            ) : (
              <button
                className="btn btn-create btn-primary"
                onClick={() => {
                  this.handleCreateButtonClick(item, index);
                }}
              >
                <i className="wb webconnect-plus"></i>
                {' Create'}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { xanoExternalDb, getXanoExternalDbPending } = this.props.dataConnector;
    const { completeData } = xanoExternalDb ? xanoExternalDb : '';
    const { tables } = completeData ? completeData : '';
    if (getXanoExternalDbPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={getXanoExternalDbPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Xano'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {tables &&
              tables.map((item, index) => {
                return this.renderCollectionCard(item, index);
              })}
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExternalDbEdit);
